import { render, staticRenderFns } from "./intelligent-test-pape-node.vue?vue&type=template&id=5ac54f98"
import script from "./intelligent-test-pape-node.vue?vue&type=script&lang=js"
export * from "./intelligent-test-pape-node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports